
import Header from 'components/Header/Header';
import Menu from 'components/Menu/Menu';
import Sitemap from 'components/sections/Sitemap/Sitemap';
import Integrations from 'components/sections/Integrations/Integrations';
import Hero from 'components/sections/Hero/Hero';
import Intro from 'components/sections/Intro/Intro';
import Investors from 'components/sections/Investors/Investors';
import Partners from 'components/sections/Partners/Partners';
import Product from 'components/sections/Product/Product';
import Roadmap from 'components/sections/Roadmap/Roadmap';
import Social from 'components/sections/Social/Social';
import Scene from 'components/Scene/Scene';
import Controller, { ControllerSlides, ControllerInnerScroll } from 'components/Controller/Controller';
import { screens } from 'components/sections/constants';

const Home: React.FC = () => {
  return (
    <Controller>
      <Scene/>
      <Menu />
      <Header />  
      <ControllerSlides>
        <Hero slide-id={screens.HERO} scroll-next-to={screens.SITEMAP}/>
        <Sitemap slide-id={screens.SITEMAP} scroll-prev-to={screens.HERO}/>
        <Partners slide-id={screens.PARTNERS} scroll-next-to={screens.INVESTORS} scroll-prev-to={screens.SITEMAP}/>
        <Investors slide-id={screens.INVESTORS} scroll-next-to={screens.PRODUCT} scroll-prev-to={screens.PARTNERS}/>

        <ControllerInnerScroll
          isActive
          slide-id={screens.PRODUCT} 
          scroll-next-to={screens.ROADMAP} 
          scroll-prev-to={screens.INVESTORS}
          inner-slides={[
            { id: screens.PRODUCT__INNER_1 },
            { id: screens.PRODUCT__INNER_2 },
          ]}
        >
          <Product/>
          <Integrations isActive/>
        </ControllerInnerScroll>
        
        <ControllerInnerScroll 
          isActive
          slide-id={screens.ROADMAP} 
          scroll-next-to={screens.SOCIAL} 
          scroll-prev-to={screens.PRODUCT}
          inner-slides={[
            { id: screens.ROADMAP__INNER_1 },
            { id: screens.ROADMAP__INNER_2 },
            { id: screens.ROADMAP__INNER_3 },
          ]}
        >
          <Roadmap/>
        </ControllerInnerScroll>

        <Social slide-id={screens.SOCIAL} scroll-next-to={screens.SITEMAP} scroll-prev-to={screens.ROADMAP}/>
      </ControllerSlides>
    </Controller>
  )
}

export default Home;
